import React from 'react';
import { CellProps } from 'react-table';
import classNames from 'classnames';
import styles from '../assets/invoicesChanges-actions.module.scss';
import { IInvoiceChange } from 'src/types/invoiceChange';
import DeleteInvoiceChangeAction from './DeleteInvoiceChangeAction';
import ApproveInvoiceChangeAction from './ApproveInvoiceChangeAction';

const InvoiceChangeActionsColumn: React.FunctionComponent<CellProps<IInvoiceChange>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IInvoiceChange>) => {
    return (
        <div className={classNames(styles.actions)}>
            <ApproveInvoiceChangeAction data={original} />
            <DeleteInvoiceChangeAction data={original} />
        </div>
    );
};

export default InvoiceChangeActionsColumn;
